var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle215(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "212.9599655748237 597.0602473244161 16.960184639614624 17.311648516211903",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M225.92,605.74c.02,2.3-1.96,4.45-4.23,4.62-2.57.19-4.74-1.92-4.73-4.61,0-2.43,1.86-4.51,4.15-4.68,2.39-.18,4.79,2.16,4.81,4.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle215);
export default __webpack_public_path__ + "static/media/twinkle-2-15.3af4e5abf28a6b0a7103e4439d9c6571.svg";
export { ForwardRef as ReactComponent };